module.exports = __webpack_public_path__ + "static/media/em-102.90484133.png";